import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import AccountType from '@/models/Shared/AccountType';
import AccountIdentifier from '@/models/Shared/AccountIdentifier';
import PaymentState from "@/models/Accounts/Shared/Payments/PaymentState";
import Schedule from '@/models/Shared/Schedule';
import EntityIdentifier from '@/models/Shared/EntityIdentifier';
import Payee from '@/models/Accounts/Shared/Payees/Payee';
import Amount from '@/models/Shared/Amount';
import PaymentTransactionMonitoring from '@/models/Accounts/Shared/Payments/PaymentTransactionMonitoring';

export default class Payment extends BaseInstitutionEntity {
    paymentOrderId: string;
    accountId: string;
    accountType: AccountType;
    accountIdentifier: AccountIdentifier;
    walletId: string;
    amount: Amount;
    reference: string;
    scheme: string;
    schedule: Schedule;
    subTransactionType: string;
    metadata: JSON;
    state: PaymentState;
    createdBy: string;
    payeeId: string;
    payeeIdentifier: EntityIdentifier;
    payee: Payee;
    completedAtUtc: Date;
    createdAtUtc: Date;
    nextPaymentDateUtc: Date;
    updatedAtUtc: Date;
    transactionMonitoring: PaymentTransactionMonitoring;
}